import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import EditIcon from '@material-ui/icons/Edit'
import { connect } from 'react-redux'
import { actualizarCereal } from '../../../Cereal/actions'
import EdicionCereal from './EdicionCereal'

function EditarCereal (props) {
  const { data, actualizarCereal } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleUpdate = () => {
    actualizarCereal()
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleUpdate}
          title='Modificar cereal'
          content={<EdicionCereal
            initialValues={{
              nombreCorto: data.nombreCorto,
              nombreCereal: data.nombre,
              humedad: data.limiteDeHumedad,
              pesoEspecifico: data.pesoEspecifico,
              habilitado: data.habilitado,
              codigoARCA: data.codigoARCA,
              color: data.color,
              codigoInterno: data.codigoInterno,
              codigoCamaraArbitral: data.codigoCamaraArbitral,
              codigoAnalisis: data.codigoAnalisis,
              grupoEnsayo: data.grupoEnsayo,
              grupoEnsayoEmbarque: data.grupoEnsayoEmbarque
            }}
          />}
        />
      </Dialog>
      <Tooltip title={'Editar'}>
        <IconButton onClick={() => handleOpen()} style={{ outline: 'none' }}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

const mapActionsToProps = {
  actualizarCereal
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(EditarCereal)
